// ============================================================
// ONOURE — Shopify custom-main.js
// Header + Mega Menu + Mobile Nav + Responsive Video
// ============================================================

if (typeof ScrollTrigger !== "undefined") {
  ScrollTrigger.config({ ignoreMobileResize: true });
}

var mainEl = document.getElementById("MainContent");
var bodyEl = document.body;
var isIndexPage = !!(
  bodyEl.classList.contains("page-home") ||
  (mainEl && mainEl.getAttribute("data-template") === "index")
);
var isProductPage = !!(
  bodyEl.classList.contains("page-product") ||
  (mainEl && (mainEl.getAttribute("data-template") || "").indexOf("product") !== -1)
);

var hamburger = document.querySelector(".hamburger");
var mobileNav = document.querySelector(".mobile-nav");
var headerOverlay = document.querySelector(".header-bg-overlay");

var mobileMenuLockedScrollY = 0;

function getPageScrollY() {
  if (window.lenis && typeof window.lenis.scroll === "number") {
    return window.lenis.scroll;
  }
  return window.pageYOffset || document.documentElement.scrollTop || 0;
}

function applySavedScrollPosition(y) {
  if (window.lenis) {
    window.lenis.scrollTo(y, { immediate: true, force: true });
    return;
  }
  window.scrollTo({ left: 0, top: y, behavior: "auto" });
  if (typeof document.documentElement.scrollTop === "number") {
    document.documentElement.scrollTop = y;
  }
  if (typeof document.body.scrollTop === "number") {
    document.body.scrollTop = y;
  }
}

function syncHamburgerIcon() {
  if (!hamburger) return;
  var isOpen = mobileNav && mobileNav.classList.contains("open");
  var menuImg  = hamburger.querySelector(".hamburger-icon-menu");
  var closeImg = hamburger.querySelector(".hamburger-icon-close");
  if (menuImg)  menuImg.style.display  = isOpen ? "none" : "";
  if (closeImg) closeImg.style.display = isOpen ? ""     : "none";
}

function setMobileMenuScrollLock(isOpen) {
  var homeHeader = document.querySelector(".header-home");
  if (homeHeader) {
    homeHeader.classList.toggle("mobile-nav-open", !!isOpen);
  }
  if (isOpen) {
    mobileMenuLockedScrollY = getPageScrollY();
    if (window.lenis) {
      window.lenis.stop();
    } else {
      document.body.style.position = "fixed";
      document.body.style.top = "-" + mobileMenuLockedScrollY + "px";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    }
    document.documentElement.classList.add("no-scroll");
    document.body.classList.add("no-scroll");
    if (typeof window.ScrollTrigger !== "undefined" && window.ScrollTrigger.normalizeScroll) {
      window.ScrollTrigger.normalizeScroll(false);
    }
    var siteHeaderOpen = document.querySelector("header.site-header") || document.querySelector("header");
    if (siteHeaderOpen) {
      siteHeaderOpen.classList.add("is-visible");
    }
  } else {
    var y = mobileMenuLockedScrollY;
    mobileMenuLockedScrollY = 0;

    if (window.lenis) {
      window.lenis.start();
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
    }
    document.documentElement.classList.remove("no-scroll");
    document.body.classList.remove("no-scroll");

    applySavedScrollPosition(y);

    if (typeof window.ScrollTrigger !== "undefined") {
      if (typeof window.onoureApplyNormalizeScroll === "function") {
        window.onoureApplyNormalizeScroll();
      } else if (window.ScrollTrigger.normalizeScroll) {
        if (window.matchMedia("(max-width: 992px)").matches) {
          window.ScrollTrigger.normalizeScroll({ allowNestedScroll: true });
        }
      }
      if (typeof window.ScrollTrigger.refresh === "function") {
        window.ScrollTrigger.refresh();
      }
    }

    applySavedScrollPosition(y);
    requestAnimationFrame(function () {
      applySavedScrollPosition(y);
      requestAnimationFrame(function () {
        applySavedScrollPosition(y);
        lastScroll = window.pageYOffset || y;
        if (typeof updateHeaderVisibilityFromScroll === "function") {
          updateHeaderVisibilityFromScroll();
        }
      });
    });
  }
}

if (hamburger && mobileNav) {
  hamburger.addEventListener("click", function () {
    mobileNav.classList.toggle("open");
    hamburger.classList.toggle("active");
    if (headerOverlay) headerOverlay.classList.toggle("active");
    setMobileMenuScrollLock(mobileNav.classList.contains("open"));
    syncHamburgerIcon();
  });
}

if (headerOverlay && mobileNav && hamburger) {
  headerOverlay.addEventListener("click", function () {
    if (!mobileNav.classList.contains("open")) return;
    mobileNav.classList.remove("open");
    hamburger.classList.remove("active");
    headerOverlay.classList.remove("active");
    setMobileMenuScrollLock(false);
    syncHamburgerIcon();
  });
}

function closeMobileMenuForFooter() {
  if (!mobileNav || !hamburger) return;
  if (!mobileNav.classList.contains("open")) return;
  mobileNav.classList.remove("open");
  hamburger.classList.remove("active");
  if (headerOverlay) headerOverlay.classList.remove("active");
  setMobileMenuScrollLock(false);
  syncHamburgerIcon();
}

syncHamburgerIcon();

(function () {
  var groups = document.querySelectorAll(".mobile-nav-group");
  if (!groups.length) return;
  groups.forEach(function (group) {
    var label = group.querySelector(".mobile-nav-label");
    if (!label) return;
    label.addEventListener("click", function (e) {
      e.preventDefault();
      group.classList.toggle("is-open");
    });
  });
})();

function createMegaMenuVideoCrossfade(imageEl, videoEl) {
  if (!imageEl || !videoEl) return null;
  var transitionMs = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 450;
  var layers = [videoEl];
  var layerB = videoEl.cloneNode(true);
  layerB.classList.add("mega-menu-video", "mega-menu-video--layer");
  videoEl.classList.add("mega-menu-video--layer", "is-active");
  layerB.classList.remove("is-active");
  layerB.pause();
  if (window.getComputedStyle(imageEl).position === "static") {
    imageEl.style.position = "relative";
  }
  imageEl.insertBefore(layerB, videoEl.nextSibling);
  layers.push(layerB);
  var activeIndex = 0;
  var swapGen = 0;
  var pendingListener = null;
  function playLayer(layer) {
    var playPromise = layer.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }
  function clearPending() {
    if (!pendingListener) return;
    pendingListener.layer.removeEventListener(pendingListener.event, pendingListener.fn);
    pendingListener = null;
  }
  function setVideo(src, poster, instant) {
    if (!src) return;
    var activeLayer = layers[activeIndex];
    var activeSource = activeLayer.querySelector("source");
    var activeSrc = activeSource ? activeSource.getAttribute("src") || "" : "";
    if (poster && activeLayer.getAttribute("poster") !== poster) {
      activeLayer.setAttribute("poster", poster);
    }
    if (src === activeSrc && activeLayer.classList.contains("is-active")) return;
    clearPending();
    swapGen += 1;
    if (!activeSrc || instant) {
      if (activeSource) activeSource.setAttribute("src", src);
      if (poster) activeLayer.setAttribute("poster", poster);
      activeLayer.classList.add("is-active");
      layers[1 - activeIndex].classList.remove("is-active");
      activeLayer.load();
      playLayer(activeLayer);
      return;
    }
    var nextIndex = 1 - activeIndex;
    var nextLayer = layers[nextIndex];
    var nextSource = nextLayer.querySelector("source");
    var gen = swapGen;
    if (nextSource) nextSource.setAttribute("src", src);
    if (poster) nextLayer.setAttribute("poster", poster);
    nextLayer.load();
    function finishSwap() {
      if (gen !== swapGen) return;
      clearPending();
      activeLayer.classList.remove("is-active");
      nextLayer.classList.add("is-active");
      playLayer(nextLayer);
      window.setTimeout(function () { activeLayer.pause(); }, transitionMs);
      activeIndex = nextIndex;
    }
    if (nextLayer.readyState >= 2) { finishSwap(); return; }
    function onReady() { finishSwap(); }
    pendingListener = { layer: nextLayer, event: "loadeddata", fn: onReady };
    nextLayer.addEventListener("loadeddata", onReady);
  }
  return { setVideo: setVideo };
}

(function () {
  var triggers = document.querySelectorAll(".has-mega-menu");
  if (!triggers.length) return;
  triggers.forEach(function (trigger) {
    var menu = trigger.querySelector(".mega-menu");
    if (!menu) return;
    var links = menu.querySelectorAll(".mega-menu-nav .mega-link");
    var copyWrap = menu.querySelector(".mega-menu-copy");
    var videoEl = menu.querySelector(".mega-menu-video");
    var imageEl = menu.querySelector(".mega-menu-image");
    var previewImg = menu.querySelector(".mega-menu-preview-img");
    var hideTimeout;
    var megaMenuVideoPrimed = false;
    var copyTitle = copyWrap ? copyWrap.querySelector("h3") : null;
    var copyText = copyWrap ? copyWrap.querySelector("p") : null;
    var megaVideo = (videoEl && imageEl) ? createMegaMenuVideoCrossfade(imageEl, videoEl) : null;
    function setCopyFromLink(link, withVideo, instantVideo) {
      if (withVideo === undefined) withVideo = true;
      if (!copyTitle || !copyText) return;
      links.forEach(function (l) { l.classList.remove("is-active"); });
      link.classList.add("is-active");
      var t = link.getAttribute("data-title") || link.textContent.trim();
      var d = link.getAttribute("data-text") || copyText.textContent.trim();
      copyTitle.innerHTML = t;
      copyText.innerHTML = d;
      if (withVideo) {
        var src = link.getAttribute("data-video");
        var poster = link.getAttribute("data-poster") || link.getAttribute("data-image");
        if (megaVideo && src) {
          megaVideo.setVideo(src, poster, !!instantVideo);
        } else if (videoEl && src) {
          var source = videoEl.querySelector("source");
          if (poster && videoEl.getAttribute("poster") !== poster) videoEl.setAttribute("poster", poster);
          if (source && source.getAttribute("src") !== src) {
            source.setAttribute("src", src);
            videoEl.load();
            var p = videoEl.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else if (previewImg && poster && previewImg.getAttribute("src") !== poster) {
          previewImg.setAttribute("src", poster);
          previewImg.setAttribute("alt", t);
        }
      }
    }
    function openMenu() {
      document.body.classList.add("no-scroll");
      if (headerOverlay) headerOverlay.classList.add("active");
      clearTimeout(hideTimeout);
      menu.classList.add("is-open");
      if (!megaMenuVideoPrimed && (videoEl || previewImg) && links.length) {
        megaMenuVideoPrimed = true;
        var activeOpen = menu.querySelector(".mega-menu-nav .mega-link.is-active") || links[0];
        if (activeOpen) setCopyFromLink(activeOpen, true, true);
      }
    }
    function scheduleClose() {
      document.body.classList.remove("no-scroll");
      if (headerOverlay) headerOverlay.classList.remove("active");
      hideTimeout = setTimeout(function () { menu.classList.remove("is-open"); }, 150);
    }
    trigger.addEventListener("mouseenter", openMenu);
    trigger.addEventListener("mouseleave", scheduleClose);
    menu.addEventListener("mouseenter", openMenu);
    menu.addEventListener("mouseleave", scheduleClose);
    if (!links.length || !copyWrap) return;
    links.forEach(function (link) {
      link.addEventListener("mouseenter", function () { setCopyFromLink(link); });
      link.addEventListener("focus", function () { setCopyFromLink(link); });
    });
    var active = menu.querySelector(".mega-menu-nav .mega-link.is-active") || links[0];
    if (active) setCopyFromLink(active, false);
  });
})();

// ============================================================
// Header scroll show/hide
// ============================================================
var lastScroll = 0;
var headerScrollRaf = 0;
var header = document.querySelector("header.site-header") || document.querySelector("header");
var heroHeaderAnchor = document.getElementById("show-header");
var HOME_MOBILE_HEADER_MQ = "(max-width: 768px)";
// Mobile + tablet: home par hero-deferred header behaviour is breakpoint tak
var HOME_HEADER_MOBILE_MQ = "(max-width: 992px)";

/**
 * Home (desktop + mobile alike): header hero ke through hidden rehta hai, hero se
 * aage scroll karte hi appear hota hai aur wahan se standard header jaisa behave
 * karta hai. (Pehle desktop par hero par header visible tha — ab nahi.)
 */
var useHomeHeroHeader = isIndexPage && !!heroHeaderAnchor;
var STANDARD_HEADER_SCROLL = !useHomeHeroHeader && !isProductPage;

/**
 * First-time-only: hero paar karne ke baad jab header pehli dafa appear ho to use
 * thodi der visible hold karo taake user notice kar le, phir hide-on-scroll-down
 * resume ho jaye. Desktop-scoped — mobile ye pop-in/hold skip karta hai.
 */
var HOME_HEADER_FIRST_REVEAL_HOLD_MS = 1500;
var homeHeaderFirstRevealTriggered = false;
var homeHeaderFirstRevealHoldUntil = 0;

/** Home par mobile/tablet (<=992px) hai? */
function isHomeMobile() {
  return window.matchMedia(HOME_HEADER_MOBILE_MQ).matches;
}

var CMS_HEADER_SCROLL_THRESHOLD_PX  = 10;
var HEADER_SCROLL_DIR_THRESHOLD     = 12;
var PRODUCT_HEADER_SCROLL_THRESHOLD_PX = 10;
var PRODUCT_HEADER_DIR_THRESHOLD_PX    = 1;

// Home: thora sa bhi upar scroll → header foran show
var HOME_HEADER_DIR_THRESHOLD = 6;

/* Direction detection: per-frame delta ke bajaye ek hi direction me accumulate hui
   distance dekhte hain. Lenis smooth scroll me har rAF frame ka delta chhota (2-8px)
   hota hai, is liye raw `delta > threshold` slow scroll par kabhi trigger nahi hota
   aur user ko baar baar / lamba scroll karna padta hai. Direction flip hote hi
   accumulator reset ho jata hai, to hysteresis exactly `threshold` rehti hai. */
var headerDirAccum = 0;
var headerDirLast = "";

function resetHeaderScrollDir() {
  headerDirAccum = 0;
  headerDirLast = "";
}

function headerScrollDirection(delta, threshold) {
  if (!delta) return headerDirLast;
  if ((delta > 0 && headerDirAccum < 0) || (delta < 0 && headerDirAccum > 0)) {
    headerDirAccum = 0; // direction badli → dobara se ginti
  }
  headerDirAccum += delta;
  if (headerDirAccum <= -threshold) {
    headerDirLast = "up";
    headerDirAccum = 0;
  } else if (headerDirAccum >= threshold) {
    headerDirLast = "down";
    headerDirAccum = 0;
  }
  return headerDirLast;
}

// Home intro flag — 2s+2s intro ke dauraan scroll/load logic header ko na chhede
var homeIntroActive = false;

if (header && (STANDARD_HEADER_SCROLL || isProductPage)) {
  header.classList.add("is-visible");
}

function syncCmsHeaderPastThreshold(scrollY) {
  if (!STANDARD_HEADER_SCROLL) return;
  document.body.classList.toggle("cms-header-past-threshold", scrollY > CMS_HEADER_SCROLL_THRESHOLD_PX);
}

if (STANDARD_HEADER_SCROLL) {
  syncCmsHeaderPastThreshold(window.pageYOffset || 0);
}

function updateProductHeaderFromScroll() {
  if (!header || !isProductPage) return;
  var currentScroll = window.pageYOffset;
  var delta = currentScroll - lastScroll;
  if (currentScroll <= PRODUCT_HEADER_SCROLL_THRESHOLD_PX) {
    header.classList.remove("header-product--collapsed", "header-product--peek");
    header.classList.add("is-visible");
    lastScroll = currentScroll;
    return;
  }
  if (Math.abs(delta) < PRODUCT_HEADER_DIR_THRESHOLD_PX) {
    lastScroll = currentScroll;
    return;
  }
  if (delta > 0) {
    header.classList.remove("header-product--peek");
    header.classList.add("header-product--collapsed", "is-visible");
  } else {
    header.classList.remove("header-product--collapsed");
    header.classList.add("header-product--peek", "is-visible");
  }
  lastScroll = currentScroll;
}

if (isProductPage && header) {
  lastScroll = 0;
  updateProductHeaderFromScroll();
}

function updateHeaderVisibilityFromScroll() {
  headerScrollRaf = 0;
  if (!header) return;
  if (homeIntroActive) return; // intro ke dauraan kuch na karo
  if (mobileNav && mobileNav.classList.contains("open")) return;

  var currentScroll = window.pageYOffset;
  var delta = currentScroll - lastScroll;

  if (isProductPage) {
    updateProductHeaderFromScroll();
    return;
  }

  if (useHomeHeroHeader && heroHeaderAnchor) {
    // scrollPastHero > 0  →  hero khatam ho chuka hai (anchor viewport se upar nikal gaya)
    var scrollPastHero = -heroHeaderAnchor.getBoundingClientRect().bottom;
    var isMobileHome = isHomeMobile();

    // Desktop par is-fixed sirf tab jab header hero se bahar aa chuka ho.
    // First reveal ke baad fixed hi rehta hai warna scroll-up par jump karega.
    if (!isMobileHome) {
      if (!homeHeaderFirstRevealTriggered && scrollPastHero < 0) {
        header.classList.remove("is-fixed");
      } else {
        header.classList.add("is-fixed");
      }
    }

    // Hero ke andar → header hidden.
    // Mobile par hamesha; desktop par sirf first reveal se pehle (uske baad hero ki
    // position matter nahi karti, plain directional logic chalta hai).
    if ((isMobileHome || !homeHeaderFirstRevealTriggered) && scrollPastHero < -1) {
      header.classList.remove("is-visible");
      resetHeaderScrollDir();
      lastScroll = currentScroll;
      return;
    }

    syncCmsHeaderPastThreshold(currentScroll);

    /* Grace zone: hero/header boundary par turant pop-in — bilkul standard header ke
       near-top-always-visible zone jaisa, bas start page top ki jagah hero end se hota
       hai. Desktop-only; mobile ye pop-in/hold skip kar ke seedha direction follow
       karta hai. */
    if (!isMobileHome && !homeHeaderFirstRevealTriggered && scrollPastHero <= CMS_HEADER_SCROLL_THRESHOLD_PX) {
      header.classList.add("is-visible");
      homeHeaderFirstRevealTriggered = true;
      homeHeaderFirstRevealHoldUntil = Date.now() + HOME_HEADER_FIRST_REVEAL_HOLD_MS;
      resetHeaderScrollDir();
      lastScroll = currentScroll;
      return;
    }

    var dir = headerScrollDirection(delta, HOME_HEADER_DIR_THRESHOLD);
    if (dir === "up") {
      header.classList.add("is-visible");          // upar ko scroll → show
    } else if (
      dir === "down" &&
      (isMobileHome || Date.now() >= homeHeaderFirstRevealHoldUntil)
    ) {
      header.classList.remove("is-visible");       // neeche scroll → hide (hold ke baad)
    }

    lastScroll = currentScroll;
    return;
  }

  if (!STANDARD_HEADER_SCROLL) return;

  syncCmsHeaderPastThreshold(currentScroll);

  if (currentScroll <= CMS_HEADER_SCROLL_THRESHOLD_PX) {
    header.classList.add("is-visible");
    resetHeaderScrollDir();
    lastScroll = currentScroll;
    return;
  }

  var cmsDir = headerScrollDirection(delta, HEADER_SCROLL_DIR_THRESHOLD);
  if (cmsDir === "up") {
    header.classList.add("is-visible");
  } else if (cmsDir === "down") {
    header.classList.remove("is-visible");
  }

  lastScroll = currentScroll;
}

window.addEventListener("scroll", function () {
  if (!header) return;
  if (isProductPage || STANDARD_HEADER_SCROLL || useHomeHeroHeader) {
    if (headerScrollRaf) return;
    headerScrollRaf = requestAnimationFrame(updateHeaderVisibilityFromScroll);
  }
}, { passive: true });

function shouldSyncHeaderOnLoad() {
  return !!(header && (isProductPage || STANDARD_HEADER_SCROLL || useHomeHeroHeader));
}

function syncHeaderVisibilityAfterLayout() {
  if (!shouldSyncHeaderOnLoad()) return;
  if (homeIntroActive) return; // intro ke dauraan header ko na chhede
  lastScroll = getPageScrollY();
  headerScrollRaf = 0;
  requestAnimationFrame(function () {
    updateHeaderVisibilityFromScroll();
  });
}

lastScroll = getPageScrollY();

window.addEventListener("load", syncHeaderVisibilityAfterLayout);
window.addEventListener("pageshow", function (ev) {
  if (ev.persisted) {
    syncHeaderVisibilityAfterLayout();
  }
});

if (typeof window.ScrollTrigger !== "undefined") {
  window.ScrollTrigger.addEventListener("refresh", function () {
    if (shouldSyncHeaderOnLoad()) {
      syncHeaderVisibilityAfterLayout();
    }
  });
}

(function () {
  var homeHeaderMq = window.matchMedia(HOME_MOBILE_HEADER_MQ);
  function onHomeHeaderMqChange() {
    if (!document.body.classList.contains("page-home")) return;
    syncCmsHeaderPastThreshold(getPageScrollY());
    syncHeaderVisibilityAfterLayout();
  }
  if (homeHeaderMq.addEventListener) {
    homeHeaderMq.addEventListener("change", onHomeHeaderMqChange);
  } else if (homeHeaderMq.addListener) {
    homeHeaderMq.addListener(onHomeHeaderMqChange);
  }
})();



// ============================================================
// Home (desktop + mobile): load par hero view me hai to header
// initially hide rakho, phir scroll par manage hoga.
// ============================================================
(function () {
  if (!header) return;
  if (!document.body.classList.contains("page-home")) return;
  if (!useHomeHeroHeader) return;

  function initHomeDeferredHeader() {
    var anchorBottom = heroHeaderAnchor.getBoundingClientRect().bottom;
    if (anchorBottom > 0) {
      header.classList.remove("is-visible"); // hero par hide
      if (!isHomeMobile()) header.classList.remove("is-fixed");
    }
    lastScroll = getPageScrollY();
  }

  if (document.readyState === "complete") {
    initHomeDeferredHeader();
  } else {
    window.addEventListener("load", initHomeDeferredHeader);
  }
})();

// ============================================================
// Mobile (max-width 992px): hide header when footer is in view
// ============================================================
(function () {
  var footerEl = document.querySelector("footer");
  if (!footerEl) return;
  var mq = window.matchMedia("(max-width: 992px)");
  var footerIo = null;
  function onFooterIntersect(entries) {
    if (!mq.matches) return;
    entries.forEach(function (entry) {
      var inView = entry.isIntersecting;
      document.body.classList.toggle("is-footer-in-view", inView);
      if (inView && typeof closeMobileMenuForFooter === "function") closeMobileMenuForFooter();
      if (!inView && typeof updateHeaderVisibilityFromScroll === "function") {
        requestAnimationFrame(updateHeaderVisibilityFromScroll);
      }
    });
  }
  function bindFooterHeaderHide() {
    document.body.classList.remove("is-footer-in-view");
    if (footerIo) { footerIo.disconnect(); footerIo = null; }
    if (!mq.matches) return;
    footerIo = new IntersectionObserver(onFooterIntersect, { threshold: 0, rootMargin: "0px" });
    footerIo.observe(footerEl);
  }
  if (mq.addEventListener) {
    mq.addEventListener("change", bindFooterHeaderHide);
  } else {
    mq.addListener(bindFooterHeaderHide);
  }
  bindFooterHeaderHide();
})();

// ============================================================
// Responsive Video — Safari fix (mobile/desktop source picker)
// ============================================================
(function () {
  function serializeSourcesFromVideo(video) {
    var sources = video.querySelectorAll("source");
    var arr = [];
    for (var i = 0; i < sources.length; i++) {
      var s = sources[i];
      var src = (s.getAttribute("src") || "").trim();
      var media = (s.getAttribute("media") || "").trim();
      var type = (s.getAttribute("type") || "").trim();
      if (media) { arr.push({ src: src, type: type, media: media }); }
      else if (src) { arr.push({ src: src, type: type, media: "" }); }
    }
    return arr;
  }
  function pickMatchingSourceFromArray(arr) {
    var fallback = null;
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      if (item.media) {
        if (!item.src) continue;
        try { if (window.matchMedia(item.media).matches) return item; } catch (e) {}
      } else if (item.src) { fallback = item; }
    }
    return fallback || null;
  }
  function cacheResponsiveSources(video) {
    if (video.dataset.responsiveSourcesBackup) return;
    if (!video.querySelector("source[media]")) return;
    var arr = serializeSourcesFromVideo(video);
    var lazy = video.getAttribute("data-lazy-src");
    if (lazy && !arr.some(function (x) { return x.src === lazy; })) {
      arr.push({ src: lazy, type: "video/mp4", media: "(min-width: 768px)" });
    }
    if (!arr.length) return;
    if (!arr.some(function (x) { return x.src; })) return;
    video.dataset.responsiveSourcesBackup = JSON.stringify(arr);
  }
  var videoAutoplayRetryBound = new WeakSet();
  function tryPlayVideo(video) {
    if (!video || video.tagName !== "VIDEO") return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }
  function primeVideoElement(video) {
    if (!video || video.tagName !== "VIDEO") return;
    if (!video.hasAttribute("autoplay") && !video.autoplay) return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    tryPlayVideo(video);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { tryPlayVideo(video); });
    });
    if (!videoAutoplayRetryBound.has(video)) {
      videoAutoplayRetryBound.add(video);
      var retry = function () { tryPlayVideo(video); };
      video.addEventListener("loadeddata", retry, { once: true });
      video.addEventListener("canplay", retry, { once: true });
      video.addEventListener("canplaythrough", retry, { once: true });
    }
  }
  function applyResponsiveVideoToElement(video) {
    if (!video || video.tagName !== "VIDEO") return;
    cacheResponsiveSources(video);
    if (!video.dataset.responsiveSourcesBackup) return;
    var arr = JSON.parse(video.dataset.responsiveSourcesBackup);
    var chosen = pickMatchingSourceFromArray(arr);
    if (!chosen || !chosen.src) return;
    var url = chosen.src;
    var last = video.dataset.responsiveAppliedUrl || "";
    if (last === url) { primeVideoElement(video); return; }
    video.innerHTML = "";
    video.removeAttribute("src");
    video.src = url;
    video.dataset.responsiveAppliedUrl = url;
    if (video.getAttribute("data-lazy-src")) {
      video.dataset.lazyLoaded = "1";
      video.removeAttribute("data-lazy-src");
    }
    video.load();
    primeVideoElement(video);
  }
  function initResponsiveVideos() {
    document.querySelectorAll("video").forEach(function (v) { applyResponsiveVideoToElement(v); });
    document.querySelectorAll("video").forEach(primeVideoElement);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initResponsiveVideos);
  } else {
    initResponsiveVideos();
  }
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll("video[data-responsive-sources-backup]").forEach(function (v) {
        delete v.dataset.responsiveAppliedUrl;
        applyResponsiveVideoToElement(v);
      });
    }, 200);
  }, { passive: true });
  window.addEventListener("orientationchange", function () {
    setTimeout(function () {
      document.querySelectorAll("video[data-responsive-sources-backup]").forEach(function (v) {
        delete v.dataset.responsiveAppliedUrl;
        applyResponsiveVideoToElement(v);
      });
    }, 300);
  }, { passive: true });
  window.addEventListener("pageshow", function (ev) {
    if (!ev.persisted) return;
    document.querySelectorAll("video").forEach(function (v) {
      if (!v.hasAttribute("autoplay") && !v.autoplay) return;
      tryPlayVideo(v);
    });
  });
  window.addEventListener("load", function () {
    document.querySelectorAll("video").forEach(function (v) {
      if (!v.hasAttribute("autoplay") && !v.autoplay) return;
      if (!v.paused) return;
      tryPlayVideo(v);
    });
  }, { once: true });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState !== "visible") return;
    document.querySelectorAll("video").forEach(function (v) {
      if (!v.hasAttribute("autoplay") && !v.autoplay) return;
      if (!v.paused) return;
      tryPlayVideo(v);
    });
  });
  window.applyResponsiveVideoToElement = applyResponsiveVideoToElement;
  window.primeVideoElement = primeVideoElement;
})();